module.exports = __webpack_public_path__ + "static/media/veneto-village-31.3ae47660.jpg";